<template>
  <svg class="icon icon--search" width="31px" height="30px" viewBox="0 0 31 30" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" transform="translate(0.000000, -5.000000)">
      <g fill="#FFFFFF" fill-rule="nonzero">
        <path d="M30.7523985,33.8328789 L21.035088,24.3711511 C25.0124438,19.7831469 24.8682186,12.7495763 20.4387921,8.42408764 C18.1767729,6.21596424 15.1701864,5 11.9720444,5 C8.77456878,5 5.76798223,6.21596424 3.50696251,8.42376234 C1.24527651,10.6318857 0,13.5680262 0,16.6902373 C0,19.8130989 1.24527651,22.7485888 3.50696251,24.9567122 C5.76798223,27.1648356 8.77490192,28.3807998 11.9720444,28.3807998 C14.8343815,28.3807998 17.6842931,27.2233046 19.8430389,25.4357917 L29.6643056,34.9739072 L30.7523985,33.8328789 Z M11.9721505,26.9461991 C9.166993,26.9461991 6.52952749,25.8794604 4.54599065,23.9419284 C2.56175217,22.0050816 1.46929838,19.4296988 1.46929838,16.6902286 C1.46929838,13.9511011 2.56140135,11.3753757 4.54599065,9.43852885 C6.52952749,7.50168202 9.166993,6.43460069 11.9721505,6.43460069 C14.7780097,6.43460069 17.4154752,7.50133946 19.3997137,9.43852885 C23.4944859,13.4372577 23.4944859,19.9435421 19.3997137,23.9419284 C17.4154752,25.8794604 14.7780097,26.9461991 11.9721505,26.9461991 Z" class="Shape"></path>
      </g>
    </g>
  </svg>
</template>

<script>
  export default{
    data(){
      return{}
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/icons/Search.vue